import styled from 'styled-components';

import {FlexCenterVertically} from '~/shared/theme/FlexLayout';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';

export const ExpandableContent = styled.div<{noBorder?: boolean}>`
  ${({theme, noBorder}) => !noBorder && `border-bottom: 1px solid ${theme.colors.gray500};`}
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }
`;

export const Cell = styled.div<{width?: number}>`
  display: flex;
  align-items: center;
  height: 100%;
  width: ${({width}) => width || 70}px;
  ${flipOnLTR`
    text-align: right;
    &:last-child {
      margin: 0;
    }
  `}
`;

export const MiddleCell = styled(Cell)`
  margin: 0 32px;
`;

export const ArrowCell = styled(Cell)`
  width: 34px;
  ${flipOnLTR`
    margin-left: 0px;
    padding-right: 8px;
  `}

  path {
    fill: ${({theme}) => theme.colors.contentDefault};
  }
`;

export const StyledRow = styled(FlexCenterVertically)`
  justify-content: space-between;
  height: 40px;
  padding: 0 34px;
  font-size: 14px;
  font-weight: bold;
`;

export const StyledTableHead = styled(StyledRow)`
  background: ${({theme}) => theme.colors.contentDisabled};
  color: ${({theme}) => theme.colors.primaryText};
  border-radius: 8px;
`;
